import { render } from "./SimpleImage.vue?vue&type=template&id=f8537818&scoped=true"
import script from "./SimpleImage.vue?vue&type=script&lang=js"
export * from "./SimpleImage.vue?vue&type=script&lang=js"

import "./SimpleImage.vue?vue&type=style&index=0&id=f8537818&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8537818"]])

export default __exports__